import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useStoryblokApi } from '@storyblok/vue';

interface FilterQuery {
  county_province?: { like: string | null };
  region_state?: { like: string | null };
  popular?: { is: boolean };
}

export const useNearMeStore = defineStore('nearMe', () => {
  const locations = ref([]);
  const regions = ref([]);
  const currentRegion = ref(null);
  const numberOfLocations = ref(0);
  const from = ref(0);
  const to = ref(0);
  const locationsPerPage = 15;

  const storyblokApi = useStoryblokApi();

  async function fetchLocations(page = 1, countyProvince = null, regionState = null) {
    const filterQuery: FilterQuery = {};
    
    const regionStore = useRegionStore();
    if (regionStore.isPopular()) {
      filterQuery.popular = { is: true };
    } else {
      if (countyProvince) filterQuery.county_province = { like: countyProvince };
      if (regionState) filterQuery.region_state = { like: regionState };
    }

    const { data, headers } = await storyblokApi.get('cdn/stories', {
      starts_with: 'sl',
      page: page,
      per_page: locationsPerPage,
      filter_query: filterQuery,
    });
    
    locations.value = data.stories;
    numberOfLocations.value = headers.total;
    from.value = (page - 1) * locationsPerPage + 1;
    to.value = Math.min(page * locationsPerPage, headers.total);
  }

  function showNextButton() {
    return to.value < numberOfLocations.value;
  }

  function showPreviousButton() {
    return from.value > 1;
  }

  return {
    locations,
    regions,
    currentRegion,
    numberOfLocations,
    from,
    to,
    fetchLocations,
    showNextButton,
    showPreviousButton,
  };
}); 